import React from 'react'

import fbicon from '../img/fb.svg';
import twittericon from '../img/twitter.svg';
import googleicon from '../img/google.svg';
import footerIcon from '../img/logo-inverted.png';
import { Link } from "react-scroll";

class FooterComponent extends React.Component {
	render() {
        return (
        	<footer>
	            <div class="container">
	                <div class="footer-logo">
	                    <img src={ footerIcon } />
	                </div>
	                <div class="footer-link">
	                    <ul>
	                    	<li>
                                <Link activeClass="g" className={`js-scroll-trigger`} to="about" spy={true} smooth={true} offset={-50} duration={400} >
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link activeClass="g" className={`js-scroll-trigger`} to="benefits" spy={true} smooth={true} offset={-50} duration={400} >
                                    Why Us?
                                </Link>
                            </li>
                            <li>
                                <Link activeClass="g" className={`js-scroll-trigger`} to="reqs" spy={true} smooth={true} offset={-50} duration={400} >
                                    Contact Us
                                </Link>
                            </li>
                            <li>
                                <Link activeClass="g" className={`js-scroll-trigger`} to="pricing" spy={true} smooth={true} offset={-50} duration={400} >
                                    Find Us
                                </Link>
                            </li>
                            <li>
                                <Link activeClass="g" className={`js-scroll-trigger`} to="faq" spy={true} smooth={true} offset={-50} duration={400}>
                                    FAQs
                                </Link>
                            </li>
	                    </ul>
	                </div>
	                <div class="social">
	                    <a href="#"><img src={ fbicon } /></a>
	                    <a href="#"><img src={ twittericon } /></a>
	                    <a href="#"><img src={ googleicon } /></a>
	                </div>
	                <p class="text-white text-center">&copy; 𝟏𝟗𝟖𝟗 - 𝟐𝟎𝟐𝟕 Universe PH</p>
	            </div>
	        </footer>
        );
    }
}//end class

export { FooterComponent };